// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3xjJP","detailsBorder":"styles_detailsBorder__1tjSG"};